import * as React from 'react';
import { Box, StackLayout } from '@leagueplatform/genesis-core';
import { SectionHeader } from '@leagueplatform/genesis-core-alpha';
import {
  LoadingIndicator,
  ErrorState,
} from '@leagueplatform/web-common-components';
import { useProviderServices } from '#hooks/queries/use-provider-services-query.hook.ts';
import { useWalletParams } from '#hooks/use-wallet-params.hook.ts';
import { useWalletDetailScreenLoaded } from '#pages/wallet-detail/hooks/use-wallet-detail-analytics.hook.ts';
import { BENEFIT_SCREEN_NAMES } from '#pages/wallet-detail/constants/analytics-benefit-property-names.ts';
import { selectCoverageNetworks } from './utils/select-coverage-networks.util';
import {
  NetworksCoverage,
  NoNetworkCoverage,
} from './components/network-coverage.component';

export function MedicalCoverage() {
  const { userId, benefitId } = useWalletParams();
  const { data, isLoading, isError, refetch, error } = useProviderServices(
    userId,
    benefitId,
    {
      select: selectCoverageNetworks,
    },
  );
  useWalletDetailScreenLoaded(BENEFIT_SCREEN_NAMES.COVERAGE_SUMMARY);

  const handleButtonClick = React.useCallback(() => {
    refetch();
  }, [refetch]);

  if (isLoading) {
    return <LoadingIndicator inline />;
  }

  if (isError || !data) {
    return (
      <Box
        as="section"
        css={{
          backgroundColor: '$surfaceBackgroundTertiary',
          padding: '$one',
          minHeight: '286px',
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
        }}
      >
        <ErrorState error={error} hideImage onButtonClick={handleButtonClick} />
      </Box>
    );
  }

  const { metadata, networks, isNoNetworkUser } = data;

  const hasNetworks = networks.length > 0;

  return (
    <StackLayout as="section" spacing="$oneAndHalf" css={{ width: '100%' }}>
      <StackLayout spacing="$one" css={{ width: '100%' }}>
        {metadata.title && (
          <SectionHeader
            headingLevel="2"
            title={metadata.title}
            subtitle={metadata.description}
          />
        )}
      </StackLayout>
      {!isNoNetworkUser && hasNetworks && (
        <NetworksCoverage networks={networks} />
      )}
      {isNoNetworkUser && hasNetworks && (
        <NoNetworkCoverage services={networks[0]} />
      )}
      {!hasNetworks && (
        <Box css={{ width: '100%' }}>
          <ErrorState
            error={error}
            hideImage
            onButtonClick={handleButtonClick}
          />
        </Box>
      )}
    </StackLayout>
  );
}
